import { server } from "../clients/axios.client"

export const listBrands = async ()=> {
    return await server.get(`/api/base/brands/`);
}
